module.exports = __webpack_public_path__ + "static/og-721d95da6b401687e9fe5f538a1214ce.png";